/* A */
export const APP_LOAD = 'APP_LOAD';
export const APP_UNLOAD = 'APP_UNLOAD';
export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';

/* C */
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION';
export const CHECK_AUTHENTICATION_SUCCESS = 'CHECK_AUTHENTICATION_SUCCESS';
export const CHECK_AUTHENTICATION_ERROR = 'CHECK_AUTHENTICATION_ERROR';
export const CHECK_AUTHENTICATION_EXPIRY = 'CHECK_AUTHENTICATION_EXPIRY';
export const CLAREITY_LOGIN = 'CLAREITY_LOGIN';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_SUCCESS = 'CLEAR_SUCCESS';
export const CLOUDCMA_PAGE_CLICKED = 'CLOUDCMA_PAGE_CLICKED';
export const CREAWEBFORMS_PAGE_CLICKED = 'CREAWEBFORMS_PAGE_CLICKED';
export const CREADDF_PAGE_CLICKED = 'CREADDF_PAGE_CLICKED';

/* D */
export const DOMAIN_AUTHENTICATION = 'DOMAIN_AUTHENTICATION';

/* H */
export const HOME_BUTTON_CLICKED = 'HOME_BUTTON_CLICKED';
export const HEARTBEAT_REFRESH = 'HEARTBEAT_REFRESH';

/* I */
export const IMPERSONATION_PAGE_CLICKED = 'IMPERSONATION_PAGE_CLICKED';

/* L */
export const LISTINGS_PAGE_CLICKED = 'LISTINGS_PAGE_CLICKED';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

/* M */
export const MATRIX_PAGE_CLICKED = 'MATRIX_PAGE_CLICKED';

/* O */
export const OFFICE_PAGE_CLICKED = 'OFFICE_PAGE_CLICKED';

/* P */
export const POSTALCODELOOKUP_PAGE_CLICKED = 'POSTALCODELOOKUP_PAGE_CLICKED';
export const PROFILE_PAGE_CLICKED = 'PROFILE_PAGE_CLICKED';
export const PROSPECTS_PAGE_CLICKED = 'PROSPECTS_PAGE_CLICKED';

/* R */
export const RECA_PAGE_CLICKED = 'RECA_PAGE_CLICKED';
export const REDIRECT = 'REDIRECT';
export const REMAPLIST_PAGE_CLICKED = 'REMAPLIST_PAGE_CLICKED';

/* S */
export const SET_ERRORS = 'SET_ERRORS';
export const SET_TOKEN = 'SET_TOKEN';
export const SEARCH_AGENTS_PAGE_CLICKED = 'SEARCH_AGENTS_PAGE_CLICKED';
export const SEARCH_LISTINGS_PAGE_CLICKED = 'SEARCH_LISTINGS_PAGE_CLICKED';
export const SPACELIST_PAGE_CLICKED = 'SPACELIST_PAGE_CLICKED';
export const SPIN_PAGE_CLICKED = 'SPIN_PAGE_CLICKED';

/* T */
export const TRAINING_PAGE_CLICKED = 'TRAINING_PAGE_CLICKED';

/* U */
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
export const UPLOAD_IMAGE_FAIL = 'UPLOAD_IMAGE_FAIL';
